
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1afi9_4mrx9_93",
  "hidden": "awsui_hidden_1afi9_4mrx9_105",
  "no-items": "awsui_no-items_1afi9_4mrx9_108"
};
  